import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sites")({
  component: () => (
    <>
      <div className="page-header">
        <div className="page-title">Sites</div>
        <div className="page-subtitle">Manage all sites</div>
      </div>
    </>
  ),
});
